import React, { useEffect, useRef, useState } from 'react'
import ClientsStyle from './Clients'
import Button from '../../components/Button'
import api from '../../api'
import { get } from 'lodash'
import Layout from '../../components/Layout'
import { CreateUser, ErrorModal } from '../../components/Modal'
import UpdateUser from './UpdateUser'
import { Spin } from 'antd'
import { useLocation } from 'react-router-dom'
import { BG_COLOR } from '../../constants/colors'

const Clients = () => {
	const errorRef = useRef()
	const updateRef = useRef()
	const createUserRef = useRef()
	const location = useLocation()
	const statusFromLocation = location.state?.status

	const [clientData, setClientData] = useState()
	const [isLoading, setIsLoading] = useState(false)
	const [clientName, setClientName] = useState('')
	const [clientPhone, setClientPhone] = useState('')
	const [clientCode, setClientCode] = useState('')
	const [page, setPage] = useState(0)
	const [data, setData] = useState({
		data: [],
		currentPage: 0, //20
	})
	const [status, setStatus] = useState(statusFromLocation || '')

	const search = () => {
		setIsLoading(true)
		let filters = []

		// Status-based filter
		if (status === 'Active') {
			filters.push('CurrentAccountBalance gt 10')
		} else if (status === 'Inactive') {
			filters.push('CurrentAccountBalance le 10')
		}

		// CardType filter (only if there are search fields)
		if (
			clientCode.length >= 1 ||
			clientPhone.length >= 1 ||
			clientName.length >= 1
		) {
			filters.push("CardType eq 'cCustomer'")
		}

		// Search filters
		if (clientName.length >= 1) {
			filters.push(`contains(CardName, '${clientName}')`)
		}
		if (clientCode.length >= 1) {
			filters.push(`contains(U_PS, '${clientCode}')`)
		}
		if (clientPhone.length >= 1) {
			filters.push(`contains(U_Telephone, '${clientPhone}')`)
		}

		// Build final URL
		let url = `BusinessPartners?$select=CardCode,CardName,Address,U_Telephone,U_Gender,U_PS,U_workplace,CurrentAccountBalance&$orderby=CardName asc`

		// Only append $filter if there are any filters
		if (filters.length > 0) {
			url += `&$filter=${filters.join(' and ')}`
		}

		url += `&$skip=${page * 10}`

		api
			.get(url, { headers: { Prefer: 'odata.maxpagesize=10' } })
			.then((res) => {
				const resData = JSON.parse(res.data).value
				setData({
					data: [...resData],
				})
			})
			.catch((err) => {
				errorRef.current?.open(
					get(JSON.parse(err.response.data), 'error.message', ''),
				)
			})
			.finally(() => {
				setIsLoading(false)
			})
	}

	useEffect(() => {
		search()
	}, [page])

	const viewItem = (v) => {
		updateRef.current?.open(v)
	}

	const newDatas = () => {
		if ((data.data.length = 10)) {
			setPage((prevState) => prevState + 1)
		} else {
			alert('boshqa malumot yoq')
		}
	}

	const oldData = () => {
		if (page === 0) {
			alert('boshqa malumot yoq')
		} else {
			setPage((prevState) => prevState - 1)
		}
	}

	const switchClientStatus = (balance) => {
		if (balance > 10) {
			return 'Активный'
		} else {
			return 'Неактивный'
		}
	}

	return (
		<Layout>
			<ClientsStyle
				style={{
					backgroundColor: BG_COLOR,
				}}
			>
				<div className="container">
					<p className="productTitle ">Клиенты</p>
					<div className="flex flex-row gap-2 mb-4 flex-grow">
						<input
							type="text"
							className={'border-[1px] border-[#DFE2E9"] p-2 rounded-md w-full'}
							placeholder="Имя Клиента"
							defaultValue={clientName}
							onChange={(v) => setClientName(v.target.value)}
						/>
						<input
							type="text"
							className={'border-[1px] border-[#DFE2E9"] p-2 rounded-md w-full'}
							placeholder="Телефон клиента"
							defaultValue={clientPhone}
							onChange={(v) => setClientPhone(v.target.value)}
						/>
						<input
							type="text"
							className={'border-[1px] border-[#DFE2E9"] p-2 rounded-md w-full'}
							placeholder="Код клиента"
							defaultValue={clientCode}
							onChange={(v) => setClientCode(v.target.value)}
						/>
						<input
							type="text"
							className={'border-[1px] border-[#DFE2E9"] p-2 rounded-md w-full'}
							placeholder="Рабочее место"
							defaultValue={clientCode}
							onChange={(v) => setClientCode(v.target.value)}
						/>
						<select
							type="text"
							className={'border-[1px] border-[#DFE2E9"] p-2 rounded-md w-full'}
							placeholder="Статус клиента"
							defaultValue={status}
							onChange={(v) => setStatus(v.target.value)}
						>
							<option value="">Все</option>
							<option value="Active">Активный</option>
							<option value="Inactive">Неактивный</option>
						</select>
						<Button
							onClick={() => {
								setPage(0)
								search()
							}}
							isLoading={isLoading}
						>
							Поиск
						</Button>
						<Button
							onClick={() => createUserRef.current?.open()}
							isLoading={isLoading}
						>
							+Добавить
						</Button>
					</div>

					<>
						<div className="relative max-h-[68vh] overflow-auto mb-8 mt-10 ">
							<Spin spinning={isLoading}>
								<table className="w-full text-sm text-left rtl:text-right text-gray-500 ">
									<thead className="sticky top-0 text-xs text-gray-700 uppercase bg-gray-50 ">
										<tr>
											<th scope="col" className="px-6 py-4">
												Код клиента
											</th>
											<th scope="col" className="px-6 py-4">
												Имя Клиента
											</th>
											<th scope="col" className="px-6 py-4">
												Телефон
											</th>
											<th scope="col" className="px-6 py-4">
												Паспорт
											</th>

											<th scope="col" className="px-6 py-4">
												Адрес
											</th>
											<th scope="col" className="px-6 py-4">
												Статус клиента
											</th>
										</tr>
									</thead>
									<tbody>
										{data.data.map((v, i) => {
											return (
												<tr
													className="bg-white border-b  hover:bg-gray-50 "
													key={i}
													onClick={() => setClientData(v)}
												>
													<td className="px-6 py-4 font-medium text-gray-900 ">
														{get(v, 'CardCode', '')}
													</td>
													<td className="px-6 py-4">
														{get(v, 'CardName', '')}
													</td>
													<td className="px-6 py-4">
														{get(v, 'U_Telephone', '')}
													</td>
													<td className="px-6 py-4">{get(v, 'U_PS', '')}</td>

													<td className="px-6 py-4">{get(v, 'Address', '')}</td>
													<td className="px-6 py-4">
														{switchClientStatus(
															get(v, 'CurrentAccountBalance', 0),
														)}
													</td>
												</tr>
											)
										})}
									</tbody>
								</table>
							</Spin>
						</div>

						<div className="topCard">
							<div className="flex items-center gap-2">
								<Button
									disabled={page === 0}
									className={'btn'}
									onClick={oldData}
								>
									{'<'}
								</Button>
								<p>{page + 1}</p>
								<Button
									disabled={data.data.length !== 10}
									className={'btn'}
									onClick={newDatas}
								>
									{'>'}
								</Button>
							</div>
						</div>
					</>
				</div>
			</ClientsStyle>
			<ErrorModal getRef={(r) => (errorRef.current = r)} />
			{clientData && (
				<UpdateUser
					clientData={clientData}
					onClose={() => setClientData(undefined)}
				/>
			)}
			<CreateUser getRef={(r) => (createUserRef.current = r)} />
		</Layout>
	)
}

export default Clients
